import { useEffect } from "react";

const DEFAULT_TITLE = "Explorer";

export const usePageTitle = (title: string) => {
  useEffect(() => {
    document.title = title;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
};
